module.exports = __webpack_public_path__ + "static/img/22.dfe8e2de.png";